import MuiPaper, { PaperProps } from '@mui/material/Paper'

export const Paper = (props: PaperProps) => {
    return (
        <MuiPaper {...props} />
    )
}